import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";

const EditModal = ({ show, handleClose, user, userType }) => {
  const renderModalContent = () => {
    switch (userType) {
      case "farmer":
        return (
          <div>
            <p>Edit Farmer Details...</p>
            <Row>
              <Col md={6}>
                <input
                  type="text"
                  placeholder="Farmer Name"
                  defaultValue={user.name}
                  className="form-control"
                />
              </Col>
              <Col md={6}>
                <input
                  type="text"
                  placeholder="Farm Location"
                  defaultValue={user.farmLocation}
                  className="form-control"
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={6}>
                <input
                  type="text"
                  placeholder="Crop Type"
                  defaultValue={user.cropType}
                  className="form-control"
                />
              </Col>
              <Col md={6}>
                <input
                  type="text"
                  placeholder="Contact Number"
                  defaultValue={user.contactNumber}
                  className="form-control"
                />
              </Col>
            </Row>
          </div>
        );
      case "consultant":
        return (
          <div>
            <p>Edit Consultant Details...</p>
            <Row>
              <Col md={6}>
                <input
                  type="text"
                  placeholder="Consultant Name"
                  defaultValue={user.name}
                  className="form-control"
                />
              </Col>
              <Col md={6}>
                <input
                  type="text"
                  placeholder="Expertise Area"
                  defaultValue={user.expertiseArea}
                  className="form-control"
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={6}>
                <input
                  type="text"
                  placeholder="Contact Number"
                  defaultValue={user.contactNumber}
                  className="form-control"
                />
              </Col>
              <Col md={6}>
                <input
                  type="text"
                  placeholder="Email"
                  defaultValue={user.email}
                  className="form-control"
                />
              </Col>
            </Row>
          </div>
        );
      case "supplier":
        return (
          <div>
            <p>Edit Supplier Details...</p>
            <Row>
              <Col md={6}>
                <input
                  type="text"
                  placeholder="Supplier Name"
                  defaultValue={user.name}
                  className="form-control"
                />
              </Col>
              <Col md={6}>
                <input
                  type="text"
                  placeholder="Company Name"
                  defaultValue={user.companyName}
                  className="form-control"
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={6}>
                <input
                  type="text"
                  placeholder="Contact Number"
                  defaultValue={user.contactNumber}
                  className="form-control"
                />
              </Col>
              <Col md={6}>
                <input
                  type="text"
                  placeholder="Email"
                  defaultValue={user.email}
                  className="form-control"
                />
              </Col>
            </Row>
          </div>
        );
      default:
        return <p>No user type selected.</p>;
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered className="custom-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          {/* Edit {userType.charAt(0).toUpperCase() + userType.slice(1)} */}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{renderModalContent()}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            /* Add save logic here */
          }}
        >
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditModal;
